import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {useNavigate} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import Button from 'shared/ui/Button/Button/Button';

import styles from '../Auth.module.scss';

const NewPasswordComplete: React.FC = () => {
    const navigate = useNavigate();

    const handleContinue = () => {
        navigate(AppUrls.HOME);
    };

    return (
        <>
            <div>
                <h2 className={styles.title}>
                    {t`Пароль успешно изменен`}
                </h2>
            </div>

            <Button
                onClick={handleContinue}
                block
            >
                {t`Продолжить`}
            </Button>
        </>
    );
};

export default NewPasswordComplete;